import React from 'react'

const AssociationApprovals = () => {
  return (
    <div className='AssociationApprovals'>
        <p>There are currently no approvals.</p>
    </div>
  )
}

export default AssociationApprovals